import * as constants from '../constants';
import { Messages } from '../models';


export interface SearchMessageRequest {
  type: constants.SEARCH_MESSAGE_REQUEST;
  text: string;
}

export interface SearchMessageSuccess {
  type: constants.SEARCH_MESSAGE_SUCCESS;
  messages: Messages;
}


export const searchMessageRequest = (text: string): SearchMessageRequest => {
  return {
    text,
    type: constants.SEARCH_MESSAGE_REQUEST,
  };
};

export const searchMessageSuccess = (messages: Messages): SearchMessageSuccess => {
  return {
    messages,
    type: constants.SEARCH_MESSAGE_SUCCESS,
  };
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/searchMessage.ts